import { render, staticRenderFns } from "./ModalRoute.vue?vue&type=template&id=72f29ede&"
import script from "./ModalRoute.vue?vue&type=script&lang=js&"
export * from "./ModalRoute.vue?vue&type=script&lang=js&"
import style0 from "./ModalRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports